import { render, staticRenderFns } from "./AwaitingProjectCard.vue?vue&type=template&id=b9f63eba&scoped=true"
import script from "./AwaitingProjectCard.vue?vue&type=script&lang=js"
export * from "./AwaitingProjectCard.vue?vue&type=script&lang=js"
import style0 from "./AwaitingProjectCard.vue?vue&type=style&index=0&id=b9f63eba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f63eba",
  null
  
)

export default component.exports